import { httpClient } from '@/modules/common/services/http/http-client';
import { featureFlag } from '@/modules/common/helpers/feature-flag/feature-flag';
import { FeatureFlags } from '@/types/models/FeatureFlags';

const bffTradeBaseURL = `${process.env.VUE_APP_BFF_URL}/trade/v1`;
export const httpClientBffTrade = httpClient.withOptions({
  baseURL: bffTradeBaseURL
});

const bffTradingBaseURL = `${process.env.VUE_APP_BFF_URL}/trading/v1`;
export const httpClientBffTrading = httpClient.withOptions({
  baseURL: bffTradingBaseURL
});

export async function postHomeBrokerToken(
  customerId: string
): Promise<{ token: string }> {
  const isNewHomeBrokerEnabled = await featureFlag.isEnabled(
    FeatureFlags.ENABLE_NEW_HOMEBROKER
  );
  if (isNewHomeBrokerEnabled) {
    return httpClientBffTrading.post(`/home-broker/generate-token/`);
  } else {
    return httpClient.post<{ token: string }>(
      `api/v1/trade/customers/${customerId}/generate-hb-token`
    );
  }
}

export function requestHomeBrokerAccess(): Promise<void> {
  return httpClientBffTrade.get('/requestHomeBrokerAccess');
}

export function getHomeBrokerUrl(): Promise<string> {
  return httpClientBffTrade.get('/getHomeBrokerUrl');
}
